
export const edit = theme => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        padding: '24px 34px 24px 32px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
    textField: {
        // marginLeft: theme.spacing(1),
        // marginRight: theme.spacing(1),
        // width: `calc(100% - ${theme.spacing(2)}px)`
    },
    input: {
    },
    textCapitalize: {
        textTransform: 'capitalize'
    },
    label: {
        fontWeight: 410
    },
    chip: {
        margin: theme.spacing(1),
    },
    dense: {
        marginTop: 16,
    },
    labelTextField: {
        backgroundColor: '#fff',
    },
    button: {
        margin: theme.spacing(1),
        width: '100%',
        height: '40px',
        borderradius: '4px',
        boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.5)'
    },
    formControl: {
        margin: theme.spacing(1),
    },
    wrapButtonReport: {
        justifyContent: 'center',
        display: 'flex',
        width: '100%',
        marginTop:18,
        marginBottom:22
    },
    wrapButtonSave: {
        justifyContent: 'center',
        display: 'flex',
        width: '100%',
    },
    containerImage: {
        position: 'relative',
        borderRadius: '50%',
        margin: 'auto',
        width: '10vw',
        height: '10vw',
        // border: '2px solid #F2F2F2',
        boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        cursor: 'pointer',
    },
    camera: {
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        width: '2rem',
        height: '2rem',
        marginTop: '65%',
        marginLeft: '65%',
        border: '4px solid #fff',
        backgroundColor: ' #ff513f',
        borderRadius: '50%',
    },
    iconCamera: {
        width: '1.3rem'
    },
    rootLabel: {
        fontSize: '1rem',
        // fontWeight: 'bold',
        // color: '#292f48 !important',
        whiteSpace: 'nowrap'
    },
    disabledRootLabel: {
        // fontSize: '1rem',
        // fontWeight: 'bold',
        // color: '#292f48 !important',
        whiteSpace: 'nowrap'
    },
    containerItems: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    backgroundButton: {
        width: '100%',
        textAlign: 'right'
    },
    editFormContainer: {        
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        padding: theme.spacing(3),
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
    }
});

